// extracted by css-extract-rspack-plugin
export default {"root":"root-wPRFC9","title":"title-zc9ivs text-sm-bold","content":"content-cknT4W text-sm-regular"};